import api from '../service/service.js'
import Swal from 'sweetalert2'
export default {
  name: 'round_lis',
  data () {
    return {
      roundModal: 0,
      familyall: [],
      popAddRound: false,
      window: {
        width: 0,
        height: 0
      },
      open: false,
      searched: '',
      listitem: [],
      datas: [],
      page: {
        page: 1,
        rowPerpage: 5
      },
      datalist: []
    }
  },
  components: {
  },
  computed: {
    pages () {
      return this.page.rowPerpage
        ? Math.ceil(this.listFilter.length / this.page.rowPerpage)
        : 0
    },
    pagesleft () {
      if (this.page.page === 1) {
        return 0
      }
      return (this.page.page - 1) * this.page.rowPerpage
    },
    pagesright () {
      if (this.page.page === this.pages) {
        return this.listFilter.length
      } else {
        return this.page.page * this.page.rowPerpage
      }
    },
    listFilter () {
      var myNewStr = this.searched.substr(-1)
      var str = this.searched.split(' ')
      console.log(this.datalist)
      for (let i = this.datalist.length; i >= str.length; i--) {
        this.datalist.pop()
      }
      console.log(this.datalist)
      if (myNewStr === ' ') {
        this.datalist.push(this.listitem)
        console.log(this.datalist)
      }
      console.log(this.familyall)
      if (str.length > 1) {
        this.datas = this.datalist[str.length - 2].filter(roundAlls => {
          if (
            roundAlls.family_id
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.address_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.moo_name
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.moo_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.tambon
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.district
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.province
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
          ) {
            return (
              roundAlls.family_id
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.address_number
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.moo_name
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.moo_number
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.tambon
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.district
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.province
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase())
            )
          }
        })
      } else {
        this.datas = this.familyall.filter(roundAlls => {
          console.log(this.searched)
          if (
            roundAlls.family_id
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.address_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.moo_name
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.moo_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.tambon
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.district
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.province
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
          ) {
            return (
              roundAlls.family_id
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.address_number
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.moo_name
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.moo_number
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.tambon
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.district
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              roundAlls.province
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase())
            )
          }
        })
      }
      console.log(this.datas)
      if (myNewStr === ' ') {
        this.datas = this.listitem
        return this.datas
      } else {
        this.listitem = []
        this.listitem = this.datas
      }
      console.log(this.datas)
      return this.datas
    },
    widthsize () {
      if (this.window.width <= 855) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    pagechange (val) {
      this.page.page = val
    },
    pagecgange (val) {
      console.log(this.pages)
      if (val === 1) {
        if (this.page.page < this.pages) {
          this.page.page += 1
        }
      } else {
        if (this.page.page !== 1) {
          this.page.page -= 1
        }
        return 1
      }
    },
    edit (index) {
      let ds = this.familyall[index]
      ds.open = !this.familyall[index].open
      this.familyall.splice(index, 1, ds)
    },
    change (val, index) {
      val.lname = val.lname
      this.familyall[index].open = !this.familyall[index].open
      console.log(this.familyall[index].open)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    familyDetail () {
      api.familyDetail(
        result => {
          console.log(result)
          if (result.result === true) {
            console.log(result.data)
            for (var i = 0; i < result.data.length; i++) {
              result.data[i].open = false
              this.familyall.push(result.data[i])
            }
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    familyDelete (val) {
      console.log('familyDelete:', val.family_id)
      Swal.fire({
        title: 'ยืนยันการอนุมัติ?',
        text: 'เมื่อยืนยันระบบจะทำการอนุมัติบิลนี้!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          let payload = val.family_id
          api.familyDelete(
            payload,
            result => {
              console.log(result)
              if (result.result === true) {
                this.alert_msg(
                  'success',
                  'ข้อความจากระบบ',
                  'บันทึกสำเร็จ '
                )
              }
              location.reload()
            },
            error => {
              alert(error)
              console.log(error)
            })
        }
      })
    },
    goindex (val) {
      this.$router.push({ name: 'edit_family', params: { id: val.family_id } })
    },
    goindexadd () {
      this.$router.push({ name: 'add_family', params: { id: 0 } })
      // this.$router.push({name: 'add_family'})
    }
  },
  mounted () {
    this.familyDetail()
  }
}



// WEBPACK FOOTER //
// ./src/js/family_lis.js